// frontend/src/components/EdicaoModal.jsx

import React, { useState, useEffect } from 'react';

const API_BASE_URL = 'https://sigoapi.jhe-etes.com.br/api';

function EdicaoModal({ isOpen, onClose, empreendimento, onUpdateSuccess }) {
  const [formData, setFormData] = useState({
    nome: '',
    descricao_curta: '',
    descricao_completa: '',
    status_atual: '',
    vazao_atual_ls: '',
    vazao_futura_ls: '',
    populacao_atendida: '',
    fluxograma_url: '' // <--- Campo para o Fluxograma
  });

  const [uploading, setUploading] = useState(false); // Estado de carregamento do upload

  useEffect(() => {
    if (empreendimento) {
      setFormData({
        nome: empreendimento.nome || '',
        descricao_curta: empreendimento.descricao_curta || '',
        descricao_completa: empreendimento.descricao_completa || '',
        status_atual: empreendimento.status_atual || 'Operação',
        vazao_atual_ls: empreendimento.vazao_atual_ls || 0,
        vazao_futura_ls: empreendimento.vazao_futura_ls || 0,
        populacao_atendida: empreendimento.populacao_atendida || 0,
        fluxograma_url: empreendimento.fluxograma_url || '' // Carrega URL existente
      });
    }
  }, [empreendimento]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // --- FUNÇÃO NOVA: LIDA COM O UPLOAD DE ARQUIVO ---
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const data = new FormData();
    data.append('file', file);

    setUploading(true);

    try {
      // 1. Envia o arquivo para a rota de upload que criamos
      const response = await fetch(`${API_BASE_URL}/upload`, {
        method: 'POST',
        body: data
      });

      if (response.ok) {
        const result = await response.json();
        // 2. O backend devolve a URL (ex: /uploads/foto.png)
        // 3. Atualizamos o formulário com essa URL
        setFormData(prev => ({ ...prev, fluxograma_url: result.url }));
        alert("Imagem carregada com sucesso!");
      } else {
        alert("Erro ao enviar imagem.");
      }
    } catch (error) {
      console.error("Erro upload:", error);
    } finally {
      setUploading(false);
    }
  };
  // ----------------------------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/empreendimentos/${empreendimento.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert("Dados atualizados com sucesso!");
        onUpdateSuccess();
        onClose();
      } else {
        alert("Erro ao salvar.");
      }
    } catch (error) {
      console.error("Erro:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto m-4 border border-gray-200">
        
        <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-gray-50">
          <h2 className="text-xl font-bold text-sabesp-blue">Editar Dados</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 font-bold">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
            
            {/* Campos existentes... (Nome, Status, Descrições) */}
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nome</label>
                    <input type="text" name="nome" value={formData.nome} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded outline-none" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                    <select name="status_atual" value={formData.status_atual} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded outline-none">
                        <option value="Operação">Operação</option>
                        <option value="Em Obras">Em Obras</option>
                        <option value="Planejamento">Planejamento</option>
                        <option value="Licitação">Licitação</option>
                        <option value="Paralisada">Paralisada</option>
                    </select>
                </div>
            </div>

            {/* --- NOVO CAMPO DE UPLOAD --- */}
            <div className="border-t border-gray-100 pt-4 mt-4">
                <h3 className="text-sm font-bold text-sabesp-blue mb-3">Imagens e Documentos</h3>
                
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Fluxograma (Imagem)</label>
                    <div className="flex gap-4 items-center">
                        <input 
                            type="file" 
                            accept="image/*" 
                            onChange={handleFileChange}
                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-sabesp-blue hover:file:bg-blue-100"
                        />
                        {uploading && <span className="text-xs text-blue-500 animate-pulse">Enviando...</span>}
                    </div>
                    
                    {/* Preview se já tiver URL */}
                    {formData.fluxograma_url && (
                        <div className="mt-3">
                            <p className="text-xs text-gray-500 mb-1">Imagem Atual:</p>
                            <img src={formData.fluxograma_url} alt="Preview" className="h-20 rounded border border-gray-300" />
                        </div>
                    )}
                </div>
            </div>
            {/* --------------------------- */}

            {/* Métricas... */}
            <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Vazão Atual</label>
                    <input type="number" name="vazao_atual_ls" value={formData.vazao_atual_ls} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded outline-none" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Vazão Futura</label>
                    <input type="number" name="vazao_futura_ls" value={formData.vazao_futura_ls} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded outline-none" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">População</label>
                    <input type="number" name="populacao_atendida" value={formData.populacao_atendida} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded outline-none" />
                </div>
            </div>

            <div className="flex gap-3 pt-4 mt-4">
                <button type="button" onClick={onClose} className="flex-1 py-2 border border-gray-300 text-gray-600 rounded hover:bg-gray-50">Cancelar</button>
                <button type="submit" disabled={uploading} className="flex-1 py-2 bg-sabesp-blue text-white font-bold rounded hover:bg-blue-800 disabled:opacity-50">
                    {uploading ? 'Aguarde...' : 'Salvar Alterações'}
                </button>
            </div>

        </form>
      </div>
    </div>
  );
}

export default EdicaoModal;